import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import Table from './../../../components/table';
import { resolveRoleName, getViceVersaFullName } from '../../../utilities/string';
import SearchBar from '../../../components/searchBar';
import { InviteUserButton } from '../../../components/richButtons';
import { getInvite, getInvites, sendInvite, updateInvite, cancelInvite, resendInvite } from '../../../reducers/invites';
import { dateToFloatingString } from '../../../utilities/dateTime';
import { Snackbar } from '../../../components/snackbar';

class InvitesList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchString: undefined,
            update: undefined
        };

        this.getColumnDefinition = this.getColumnDefinition.bind(this);
        this.getActionColumnDefinition = this.getActionColumnDefinition.bind(this);
        this.setInviteForUpdate = this.setInviteForUpdate.bind(this);
    }

    setInviteForUpdate(invite) {
        this.setState({ ...this.state, update: { invite, onPassed: () => this.setState({ ...this.state, update: undefined }) } });
    }

    getActionColumnDefinition() {
        const { resendInvite } = this.props;

        return {
            valueMap: d => (
                <div className="full-height-cell invite-actions no-select">
                    <i className="material-icons" onClick={() => resendInvite(d, () => Snackbar.success(<FormattedMessage {...messages.inviteResent} />))}>
                        autorenew
                    </i>
                </div>
            ),
            size: 'col-sm-2 col-xs-2 text-right'
        };
    }

    getColumnDefinition() {
        const { role } = this.props;
        let showCompanyColumn = role.type === 'admin';

        let columns = [
            {
                label: <FormattedMessage {...messages.name} />,
                valueMap: d => (
                    <div className="row name-column">
                        <div className="col-xs-12 name-cell ellipsis">
                            {d.first_name} {d.last_name}
                        </div>
                        <div className="col-xs-12 email-cell ellipsis">{d.email}</div>
                    </div>
                ),
                size: showCompanyColumn ? 'col-sm-3 col-xs-10' : 'col-sm-5 col-xs-10',
                sort: (a, b) => getViceVersaFullName(a).localeCompare(getViceVersaFullName(b))
            }
        ];

        if (showCompanyColumn) {
            columns = [
                ...columns,
                {
                    label: <FormattedMessage {...messages.company} />,
                    valueMap: d => (
                        <div className="full-height-cell ellipsis">{d.company_name ? d.company_name : <FormattedMessage {...messages.notProvided} />}</div>
                    ),
                    size: 'col-sm-2 hidden-xs',
                    sort: (a, b) => (a.company_name || '').localeCompare(b.company_name || '')
                }
            ];
        }

        return [
            ...columns,
            {
                label: <FormattedMessage {...messages.role} />,
                valueMap: d => (
                    <div className="full-height-cell ellipsis">{d.role ? resolveRoleName(d.role) : <FormattedMessage {...messages.notProvided} />}</div>
                ),
                size: 'col-sm-2 hidden-xs',
                sort: (a, b) => (a.role ? resolveRoleName(a.role).toString() : '').localeCompare(b.role ? resolveRoleName(b.role).toString() : '')
            },
            {
                label: <FormattedMessage {...messages.inviteDate} />,
                valueMap: d => <div className="full-height-cell ellipsis">{dateToFloatingString(d.created_at)}</div>,
                size: 'col-sm-2 hidden-xs',
                sort: (a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
            },
            {
                label: <FormattedMessage {...messages.status} />,
                valueMap: d => <div className="full-height-cell ellipsis">{d.status}</div>,
                size: 'col-sm-1 hidden-xs',
                sort: (a, b) => (a.status || '').localeCompare(b.status || '')
            },
            this.getActionColumnDefinition()
        ];
    }

    render() {
        const { invites } = this.props;
        const { searchString, update } = this.state;

        let data = searchString
            ? invites.filter(d => d.email.indexOf(searchString) >= 0 || `${d.first_name} ${d.last_name}`.indexOf(searchString) >= 0)
            : invites;

        const button = (
            <span className="button">
                <FormattedMessage {...messages.inviteUser} />
            </span>
        );
        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        <SearchBar onSubmit={d => this.setState({ ...this.state, searchString: d.value })} />
                    </div>
                    <div className="col-sm-6 col-xs-12 add-wrapper">
                        <InviteUserButton update={update} button={button} />
                    </div>
                </div>
                <div className="col-xs-12">
                    <Table data={data} columns={this.getColumnDefinition()} defaultSortColumn={0} />
                </div>
            </React.Fragment>
        );
    }
}

InvitesList.defaultProps = {
    invites: []
};
InvitesList.propTypes = {
    invites: PropTypes.array.isRequired
};

const mapStateToProps = state => ({
    role: state.identity.role,
    invites: state.invites.list
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getInvites,
            getInvite,
            sendInvite,
            updateInvite,
            cancelInvite,
            resendInvite
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InvitesList);



// WEBPACK FOOTER //
// ./src/pages/users/lists/invites.jsx